import dayjs from "dayjs";

export const INTERACTION_DATE_LOOKBACK_DAYS = 30;
export const MISSED_INTERACTION_DATE_LOOKBACK_DAYS = 14;

export const SKIP_REASONS = [
  "Multisite",
  "No relation",
  "Too many recent interactions",
  "Not interaction worthy",
  "Issue file",
  "Added too late",
  "DateDown/ConstDraw"
];

export const PRE_INTERACTION_INSTRUCTIONS = [
  "Please call them",
  "Please text them",
  "Please email them",
  "Please visit in person",
  "Follow up on previous conversation",
  "Discuss current order",
  "General check-in"
];

export const QUICK_NOTE_OPTIONS = [
  "Left voicemail",
  "Spoke with contact",
  "Discussed order status",
  "Scheduled follow-up",
  "No answer",
  "Sent information",
  "Addressed concerns"
];

export const getLastBusinessDay = () => {
  let date = dayjs();
  const dayOfWeek = date.day();

  if (dayOfWeek === 1) {
    date = date.subtract(3, "day");
  } else if (dayOfWeek === 0) {
    date = date.subtract(2, "day");
  } else {
    date = date.subtract(1, "day");
  }

  return date;
};

export const getTwoBusinessDaysAgo = () => {
  let date = dayjs();
  let businessDaysToSubtract = 2;

  while (businessDaysToSubtract > 0) {
    date = date.subtract(1, "day");
    const dayOfWeek = date.day();

    // Skip weekends (0 = Sunday, 6 = Saturday)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDaysToSubtract--;
    }
  }

  return date;
};

export const getThreeBusinessDaysAgo = () => {
  let date = dayjs();
  let businessDaysToSubtract = 3;

  while (businessDaysToSubtract > 0) {
    date = date.subtract(1, "day");
    const dayOfWeek = date.day();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDaysToSubtract--;
    }
  }

  return date;
};
